import script from "./OtpLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./OtpLogin.vue?vue&type=script&setup=true&lang=js"

import "./OtpLogin.vue?vue&type=style&index=0&id=4ebe9431&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ebe9431"]])

export default __exports__